import { useCallback, useEffect, useMemo, useRef } from 'react';

/** A→B→A is three lifetimes, not the same string identity returning. */
export function useCurrentScope(identity: string) {
  const scope = useMemo(() => ({ identity, mounted: true }), [identity]);
  const current = useRef(scope);
  current.current = scope;
  useEffect(() => {
    scope.mounted = true;
    return () => { scope.mounted = false; };
  }, [scope]);
  return useCallback(() => scope.mounted && current.current === scope, [scope]);
}